module.exports = __webpack_public_path__ + "static/media/playy.312f0515.png";